<template lang="html">
  <div class="xperts-wrapper" v-if="globalC.xpert">
    <div class="xperts">
      <div class="xperts-col-2">
        <div class="xperts-col" v-html="compiledMarkdown(globalC.xpert.content)">
        </div>
        <div class="xperts-col xperts-col-img" :style="{backgroundImage:'url('+globalC.xpert.img+')'}">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import Marked from 'marked';
export default {
  name: 'Xperts',
  computed: {
    ...mapGetters([
      'globalC'
    ])
  },
  methods:{
    compiledMarkdown(text) {
      return Marked(text, { sanitize: true })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/modular/xperts.vue